'use client'

import {FormattedMessage} from "react-intl";
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/page/create-account/create-account-page.module.scss";
import {FormProvider, useForm} from "react-hook-form";
import {FormInput} from "@/app/components/inputs/FormInput";
import {useState} from "react";
import {createCustomerAccount} from "@/app/services/CreateAccountService";
import {signIn} from "next-auth/react";

const RegisterForm = ({createAccount}) => {
    const methods = useForm({
        defaultValues: {
            full_name: '',
            email: '',
            password: '',
        }
    });

    const [passwordShown, setPasswordShown] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null)

    const onSubmit = async (data) => {
        setErrorMessage(null)
        const names = data.full_name.split(' ')
        const firstName = names[0]
        const lastName = names[1]

        const registerFormReqData = {
            email: data.email,
            first_name: firstName,
            last_name: lastName,
            password: data.password,
            billing: {
                first_name: firstName,
                last_name: lastName,
                email: data.email,
            },
            shipping: {
                first_name: firstName,
                last_name: lastName,
            }
        }
        const response = await createCustomerAccount({data: registerFormReqData})
        if (response && response.status === 400) {
            setErrorMessage(response.data.message)
        } else {
            await signIn("credentials", {
                username: data.email,
                password: data.password,
                redirect: true,
                callbackUrl: "/",
            })
        }

    }
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} className="formStyle">
                <div className="inputContainer inputWithImage">
                    <FormattedMessage id={'pages.createAccount.form.fullName'}>
                        {(message) =>
                            <FormInput
                                name={'full_name'}
                                styleLabel={''}
                                label={''}
                                type={'text'}
                                styleInput={styles.errorMessagesMargin}
                                placeholder={message}
                                registerOptions={{
                                    required: true,
                                    pattern: {
                                        value: /^[A-Za-z]+\s{0,1}[A-Za-z]*$/,
                                        message: "Ne moze postojati vise od jednog razmaka izmedju imena i prezimena"
                                    }
                                }}
                                error={methods.formState.errors?.full_name}
                            />
                        }
                    </FormattedMessage>
                    <Image
                        src={'/person.png'}
                        alt="Person"
                        width={13}
                        height={14}
                        className="inputImage"
                    />
                </div>
                <div className="inputContainer inputWithImage">
                    <FormattedMessage id={'common.form.email'}>
                        {(message) =>
                            <FormInput
                                name={'email'}
                                styleLabel={''}
                                label={''}
                                type={'email'}
                                styleInput={styles.errorMessagesMargin}
                                placeholder={message}
                                registerOptions={{required: true}}
                                error={methods.formState.errors?.email}
                            />
                        }
                    </FormattedMessage>
                    <Image
                        src={'/email-2.png'}
                        alt="Email"
                        width={14}
                        height={12}
                        className="inputImage"
                    />
                </div>
                <div className="inputContainer inputWithImage">
                    <FormattedMessage id={'common.form.password'}>
                        {(message) =>
                            <FormInput
                                name={'password'}
                                styleLabel={''}
                                label={''}
                                type={passwordShown ? 'text' : 'password'}
                                styleInput={styles.errorMessagesMargin}
                                placeholder={message}
                                registerOptions={{required: true}}
                                error={methods.formState.errors?.password}
                            />
                        }
                    </FormattedMessage>
                    <Image
                        src={'/eye-open.png'}
                        alt="Eye open"
                        width={17}
                        height={13}
                        className="inputImage"
                        onClick={() => setPasswordShown(!passwordShown)}
                    />
                </div>
                <div className="form-links-details">
                    <label className="form-links" htmlFor="create-account-checkbox">
                        <input
                            id="create-account-checkbox"
                            name="create-account-checkbox"
                            type="checkbox"
                            className="checkboxInput"
                        />
                        <FormattedMessage id={'common.form.rememberMe'}/>
                    </label>
                    <Link className="form-links" href={"/zaboravljena-lozinka"}>
                        <FormattedMessage id={'common.form.forgotPassword'}/>
                    </Link>
                </div>
                <div className="buttonContainer">
                    <button type="submit" className={`${styles.submitBtn} btnGlobal`}
                            disabled={methods.formState.isSubmitting}
                    ><FormattedMessage
                        id={'pages.createAccount.form.createAccount'}
                    /></button>
                </div>
                {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
                <div className={styles.agreeServiceText}
                     dangerouslySetInnerHTML={{__html: createAccount.create_account_agree_service}}>
                </div>
            </form>
        </FormProvider>
    )
}

export default RegisterForm